import { render, staticRenderFns } from "./KcArray.vue?vue&type=template&id=5aa46d3c&scoped=true"
import script from "./KcArray.vue?vue&type=script&lang=js"
export * from "./KcArray.vue?vue&type=script&lang=js"
import style0 from "./KcArray.vue?vue&type=style&index=0&id=5aa46d3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa46d3c",
  null
  
)

export default component.exports